<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        最新动态
      </a-typography-title>
      <a-typography-title :level="5">
        星汉未来时刻与您分享最新消息
      </a-typography-title>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
export default {
  name: 'newsBanner'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/news/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{imagePublic}banner_2.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    padding: 110px 0 30px;
    margin: 0 auto;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @banner_title, @color_white, @banner_title, true);
}

h5.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_white, @text);
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 20px;
    }
  }
  
  h1.ant-typography {
    .font(center, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  h5.ant-typography {
    .font(center, @text_mo+@line_mo, @color_white, @text_mo);
  }
}
</style>